e4.news = {
    init: function () {
        e4.news.filter.init();
        e4.news.paging();
    },
    filter: {
        timeout: null,
        init: function () {
            if ( jQuery( '.js-e-news-filter' ).length > 0 ) {
                e4.news.filter.bindEvents();
            }
            var strCurrentUrl = window.location.toString()
            
            if ( strCurrentUrl.indexOf( '?filter=' ) > 0 ) {
                jQuery( '.js-e-news-filter-option' ).each( function() {
                    var strFilterParameter =  jQuery( this ).data( 'filter' ).replace( '.filter-', '' );
                    
                    if ( strFilterParameter === '*' ) {
                        jQuery( this ).removeClass( 'active' );
                    }
                    else if ( strCurrentUrl.indexOf( '&' + strFilterParameter ) > 0 || strCurrentUrl.indexOf( '?filter=' + strFilterParameter ) > 0 ) {
                        jQuery( this ).addClass( 'active' );
                        e4.news.filter.apply( this );
                    }
                });
            }
        },
        bindEvents: function () {
            jQuery( '.js-e-news-filter' ).on( 'click', '.js-e-news-filter-option', function ( event ) {
                event.preventDefault();
                e4.news.filter.toggleControls( this );
                e4.news.filter.apply( this );
                e4.news.filter.urlFilterParameters( this );
            } );
        },
        urlFilterParameters: function ( strUrlParameter ) {
            var strFilterParameter = jQuery( strUrlParameter ).data( 'filter' ).replace( '.filter-', '' ), 
                strCurrentUrl = window.location.toString();
            
            //Pass the filter parameter to the URL
            if( strFilterParameter !== '*' && jQuery( strUrlParameter ).hasClass( 'active' )) {
                if ( strCurrentUrl.indexOf( '?filter=' ) > 0 ) {
                    e4.news.filter.updateUrl( strCurrentUrl + '&' + strFilterParameter );
                }
                else {
                    e4.news.filter.updateUrl( strCurrentUrl + '?filter=' + strFilterParameter );
                }
            }
            //Remove the filter parameter to the URL
            else if ( !jQuery( strUrlParameter ).hasClass( 'active' ) ) {
                if( strCurrentUrl.indexOf( '?filter=' + strFilterParameter ) > 0 && strCurrentUrl.indexOf( '&' ) > 0 ) {
                    strCurrentUrl = strCurrentUrl.replace( strFilterParameter + '&', '' );
                    e4.news.filter.updateUrl( strCurrentUrl );
                }
                else if ( strCurrentUrl.indexOf( '?filter=' + strFilterParameter ) > 0  && strCurrentUrl.indexOf( '&' ) <= 0 ) {
                    console.log( 'true' )
                    strCurrentUrl = strCurrentUrl.replace( '?filter=' + strFilterParameter, '' );
                    e4.news.filter.updateUrl( strCurrentUrl );
                }
                else {
                    strCurrentUrl = strCurrentUrl.replace( '&' + strFilterParameter, '' );
                    e4.news.filter.updateUrl( strCurrentUrl );
                }
            }
            else {
                if ( strCurrentUrl.indexOf( '?' ) > 0 ) {
                    var strCleanCurrentUrl = strCurrentUrl.substring( 0, strCurrentUrl.indexOf( '?' ) );
                    e4.news.filter.updateUrl( strCleanCurrentUrl );
                }
            }            
        },
        updateUrl: function ( strUrl ) {
            window.history.replaceState({}, document.title, strUrl );
        },
        toggleControls: function ( domElm ) {
            var jThis = jQuery( domElm );
            if ( jThis.data( 'filter' ) === '*' ) {
                jThis.addClass( 'active' );
                jThis.closest( '.js-e-news-filter' ).find( '.js-e-news-filter-option' ).not( '[data-filter="*"]' ).removeClass( 'active' );
            }
            else {
                jThis.toggleClass( 'active' );
                jThis.closest( '.js-e-news-filter' ).find( '.js-e-news-filter-option' ).filter( '[data-filter="*"]' ).removeClass( 'active' );
            }
        },
        apply: function ( domElm ) {
            var arrSelectorFilter = [],
                jThis = jQuery( domElm );
            jThis.closest( '.js-e-news-filter' ).find( '.js-e-news-filter-option' ).filter( '.active' ).each( function () {
                arrSelectorFilter.push( this.getAttribute( 'data-filter' ) );
            } );
            if ( arrSelectorFilter.length === 0 ) {
                arrSelectorFilter.push( '*' );
                jThis.closest( '.js-e-news-filter' ).find( '.js-e-news-filter-option' ).filter( '[data-filter="*"]' ).addClass( 'active' );
            }
            jThis.closest( '.js-e-news' ).css( 'min-height', function () {
                return this.scrollHeight;
            } ).addClass( 'is-filtering' );
            if ( e4.news.filter.timeout !== null ) {
                clearTimeout( e4.news.filter.timeout );
                e4.news.filter.timeout = null;
            }
            e4.news.filter.timeout = setTimeout( function () {
                jThis.closest( '.js-e-news' ).find( '.js-e-news-item' ).removeClass( 'd-none' ).not( arrSelectorFilter.join( ',' ) ).addClass( 'd-none' );
                jQuery( '.js-e-news' ).removeClass( 'is-filtering' ).css( {
                    'min-height': 0
                } );
            }, e4.settings.animation.speed );

        }
    },
    paging: function () {
        var jNewsPaging = jQuery( '.js-e-news-pagination' );
        if ( jNewsPaging.length === 1 ) {
            jNewsPaging.find( 'a' ).not( '.js-e-news-pagination-item' ).addClass( 'page-link' );
            var jNewsPagingList = jQuery( '.js-e-news-pagination-list-dw' ).find( 'a' ),
                jNewsPagingItemTemplate = jQuery( '.js-e-news-pagination-item' ),
                jNewsPagingListNew = [];
            jNewsPagingList.each( function () {
                var jThis = jQuery( this ),
                    jNewsPagingItemNew = jNewsPagingItemTemplate.clone();
                jNewsPagingItemNew.find( 'a' ).attr( 'href', jThis.attr( 'href' ) ).text( jThis.text() );
                if ( jThis.find( 'b' ).length === 1 ) {
                    jNewsPagingItemNew.addClass( 'active' );
                }
                jNewsPagingListNew.push( jNewsPagingItemNew );
            } );
            jNewsPagingItemTemplate.replaceWith( jNewsPagingListNew );
        }
    }
};

